import FieldDropdownLazyLoading from "../../../generic/dropdown-lazy-loading/dropdown-lazy-loading";
import FieldConfig from "../../../proto/field-config";
import RequestFormsCollection from "../../../../../app/tools/request-forms2/model/collection"

// const debug = "FieldRequestFormSelect"
const debug = false

export default class FieldRequestFormSelect extends FieldDropdownLazyLoading {

    // public _options     : any

    constructor(config:FieldConfig) {
        super(config);

        debug && console.log(debug, "constructor()) sessionIsLoaded =", gd.session.requestFormsLoaded)

        this.noValueOption     = false // always should have a value!

        if (gd.session.requestFormsLoaded) {
            this._options   = (gd.session.requestForms as RequestFormsCollection).toOptions()
            this.isLoaded   = true
        } else {
            // special
            this._options    = null; //_.get(config,'options',[]); // [{value, label, color},...]
            this.isLoaded    = false
        }


        // modify popover
        this.classes.PopoverMenu    = "min-w-200"

    }

    async loadOptions(callback?: callback): Promise<void> {

        const requestForms = await gd.session.requestForms

        this._options   = requestForms.toOptions()
        this.isLoaded   = true

        if (callback) {
            callback()
        }


    }

    // assumed to be redefined
    getOptions() {
        return this._options || [];
    }

    //
    // getOptions() {
    //     return this.options || [];
    // }
    //
    // /*** IMPORT EXPORT ***/
    //
    // toJson() {
    //     let result = super.toJson();
    //     result.options = this.options;
    //
    //     return result;
    // }


}
